import legalInfos from "./legalPartnersInfos";
import getWhiteLabel from "../../../utils/getWhiteLabel";

function getPartnerKey() {
    if (!legalInfos[getWhiteLabel(true)]) {
        return 'cashforce';
    } else {
        return getWhiteLabel(true);
    }
}

const defaultCashforce = {
    1.1: 'Cashforce Serviços de Tecnologia da Informação Ltda., sociedade empresária, inscrita no CNPJ/MF sob n.º 36.047.250/0001-24, criadora e desenvolvedora da Plataforma.',
    1.6: 'A Plataforma é Solução de tecnologia (SaaS) ofertada como aplicativo e/ou site de internet, criada e desenvolvida pela Cashforce Serviços de Tecnologia da Informação Ltda., sociedade empresária, inscrita no CNPJ/MF sob n.º 36.047.250/0001-24, na qual, por meio de Conta gratuita vinculada aos Fornecedores e seus Usuários, é possibilitado o oferecimento e a contratação de Serviços. Especificamente, é ferramenta de gestão do relacionamento financeiro, focada no entendimento da cadeia produtiva, fazendo interface com os principais sistemas ERPs para permitir que compradores, seus Fornecedores e Parceiros tenham visibilidade nas transações, além de crédito automatizado, acomodando modelos de operações e negócios variados.'
}

const termsInfo = [
    [
        {
            index: `1.1`,
            title: `${legalInfos[getPartnerKey()].nome}`,
            content: getPartnerKey() === 'cashforce' ? defaultCashforce["1.1"] : `${legalInfos[getPartnerKey()].razaoSocial}, sociedade empresária, inscrita no CNPJ/MF sob n.º ${legalInfos[getPartnerKey()].cnpj}, contratante e operadora da Plataforma.`,
        },
        {
            index: `1.2`,
            title: `Conta`,
            content: `Cadastro do Usuário na Plataforma para representação e atuação no interesse do Fornecedor, criado mediante preenchimento de todos os dados necessários para criação de seu perfil e aceite do Termo.`,
        },
        {
            index: `1.3`,
            title: `Leis`,
            content: `Qualquer ato normativo, seja legal ou administrativo, validamente emitido por autoridade competente, de todas as esferas nacionais ou, ainda, internacionais, desde que recepcionado no Brasil.`,
        },
        {
            index: `1.4`,
            title: `Fornecedor`,
            content: `Qualquer pessoa jurídica, que atua no comércio varejista e atacadista, que fornece produtos ou serviços, bem como as holdings, grupos econômicos, associações, cooperativas, controladoras e outras entidades do gênero, com relação de independência e desvinculação quanto à ${legalInfos[getPartnerKey()].razaoSocial}, sendo o Fornecedor representado na Plataforma por um ou mais Usuários autorizados, sob sua responsabilidade direta e exclusiva.`,
        },
        {
            index: `1.5`,
            title: `Parceiro`,
            content: `Pessoa jurídica, tais como banco, factoring, FIDC, SCD, ESC, securitizadora, agente independente de crédito e empresa de fomento mercantil, que poderá oferecer Serviço na Plataforma, sob sua responsabilidade única, direta e exclusiva.`,
        },
        {
            index: `1.6`,
            title: `Plataforma`,
            content: getPartnerKey() === 'cashforce' ? defaultCashforce["1.6"] : `A Plataforma é Solução de tecnologia (SaaS) ofertada como aplicativo e/ou site de internet, criada e desenvolvida pela Cashforce Serviços de Tecnologia da Informação Ltda., sociedade empresária, inscrita no CNPJ/MF sob n.º 36.047.250/0001-24, contratada pela ${legalInfos[getPartnerKey()].razaoSocial} na qual, por meio de Conta gratuita vinculada aos Fornecedores e seus Usuários, é possibilitado o oferecimento e a contratação de Serviços. Especificamente, é ferramenta de gestão do relacionamento financeiro, focada no entendimento da cadeia produtiva, fazendo interface com os principais sistemas ERPs para permitir que compradores, seus Fornecedores e Parceiros tenham visibilidade nas transações, além de crédito automatizado, acomodando modelos de operações e negócios variados.`,
        },
        {
            index: `1.7`,
            title: `Serviço`,
            content: `Prestação de qualquer serviço ofertado por Parceiros, tais como serviços logísticos, creditórios e gestão de compras, entre outros, oferecidos na Plataforma, com livre adesão pelos Fornecedores.`,
        },
        {
            index: `1.8`,
            title: `Usuário`,
            content: `Pessoa natural que, devidamente autorizada pelo Fornecedor, o representará para todos os fins legais e decorrentes do presente termo, para todas as funcionalidades tornadas disponíveis no ambiente da Plataforma e na prática dos atos de interesse do Fornecedor, por intermédio de Contas devidamente cadastradas, atuando no fiel cumprimento de suas atribuições, permanecendo-se diretamente vinculado ao Fornecedor para todos os fins.`,
        }
    ],
    [
        {
            index: `2.1`,
            title: ``,
            content: `Este Termo vincula Fornecedores e seus Usuários que utilizam a Plataforma com o intuito de, à sua livre escolha, contatar e negociar Serviços oferecidos por Parceiros na Plataforma.`,
        },
        {
            index: `2.2`,
            title: ``,
            content: `A eventual e livre contratação dos Serviços pelo Fornecedor junto ao Parceiro será regulada por instrumentos disponibilizados pelo próprio Parceiro.`,
        },
        {
            index: `2.2.1`,
            title: ``,
            content: `As formas e conteúdos desses instrumentos serão de responsabilidade exclusiva do Parceiro, bem como a adesão e o aceite desses instrumentos serão de exclusiva responsabilidade do Fornecedor. A ${legalInfos[getPartnerKey()].razaoSocial}, em nenhuma hipótese, terá qualquer responsabilidade por estes instrumentos e/ou pelas negociações relativas a eles.`,
        },
    ],
    [
        {
            index: `3.1`,
            title: ``,
            content: `O Fornecedor utilizará a Plataforma por intermédio de Conta criada por Usuário a ele vinculado.`,
        },
        {
            index: `3.2`,
            title: ``,
            content: `A criação de Conta na Plataforma será realizada com o preenchimento completo de todos os dados pessoais, de Usuário, Fornecedor e seus sócios, solicitados pela ${legalInfos[getPartnerKey()].razaoSocial}, e sua validação estará condicionada ao aceite deste Termo e demais condições da Plataforma.`,
        },
        {
            index: `3.3`,
            title: ``,
            content: `O Usuário é responsável por fornecer, atualizar e garantir a veracidade dos dados informados, sob pena de responder por crime de falso. Ademais, o Usuário declara e garante, para todos os efeitos legais, atuar como mandatário ou autorizado do Fornecedor para o envio e disponibilização de todo e qualquer documento, inclusive sigilosos, de sócios e representantes legais, o que pode incluir Imposto de Renda Pessoa Física, dados sobre residência, certidões e quaisquer dados necessários para que o Usuário e o Fornecedor possam se relacionar com os Parceiros, sendo irrevogável a autorização para o compartilhamento, pela ${legalInfos[getPartnerKey()].razaoSocial}, dos documentos e informações em questão, os quais são apresentados pelo Usuário.`,
        },
        {
            index: `3.3.1`,
            title: ``,
            content: `O Usuário expressamente consente o compartilhamento, pela ${legalInfos[getPartnerKey()].razaoSocial}, dos dados e documentos fornecidos, inclusive sigilosos, de sócios e representantes legais, o que pode incluir Imposto de Renda Pessoa Física, dados sobre residência, certidões e quaisquer dados necessários para que o Usuário e o Fornecedor possam se relacionar com os Parceiros.`,
        },
        {
            index: `3.3.2`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} não terá nenhum tipo de responsabilidade civil ou criminal resultante de dados não autorizados, inverídicos, incorretos ou incompletos fornecidos pelo Usuário.`,
        },
        {
            index: `3.4`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} se reserva o direito de utilizar todos os meios válidos e possíveis para identificar Usuário, Fornecedor e seus sócios, bem como solicitar dados adicionais e documentos que estime pertinentes, a fim de conferir os dados pessoais informados.`,
        },
        {
            index: `3.5`,
            title: ``,
            content: `A Plataforma e os Serviços nela disponibilizados são fornecidos exclusivamente a Fornecedores devidamente regularizados junto aos órgãos competentes, sendo estes Fornecedores, por seus Usuários, exclusivamente responsáveis pela manutenção e prova da regularidade, sob pena de limitação ou exclusão de acesso à Plataforma, prescindindo de notificação prévia, a critério exclusivo da ${legalInfos[getPartnerKey()].razaoSocial}.`,
        },
        {
            index: `3.5.1`,
            title: ``,
            content: `Nestes casos, a ${legalInfos[getPartnerKey()].razaoSocial} poderá, ainda, assim que tomar conhecimento, impedir e bloquear negociações por meio da Plataforma ou cancelar as já realizados, sem prejuízo de outras medidas que entenda necessárias e oportunas.`,
        },
        {
            index: `3.5.2`,
            title: ``,
            content: `No caso de aplicação de quaisquer das medidas preventivas ou reparatórias listadas neste item, não assistirá ao Fornecedor o direito a qualquer tipo de indenização ou ressarcimento por perdas e danos, lucros cessantes ou danos morais, sobretudo pelo caráter preventivo de medidas nesse sentido.`,
        },
        {
            index: `3.6`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} não explora ou de qualquer forma compartilha com terceiros os dados dos Fornecedores, salvo aqueles cujo compartilhamento seja expressamente consentido por ocasião da assinatura do presente Termo e estejam de acordo com suas finalidades, nos limites e outras condições estabelecidas na Política de Privacidade, ou por requisição dos órgãos competentes, nos termos legais.`,
        },
        {
            index: `3.6.1`,
            title: ``,
            content: `A Política de Privacidade é documento vinculado ao presente Termo. O credenciamento na Plataforma está diretamente vinculado à ciência e expresso consentimento às disposições deste Termo e da Política de Privacidade de Dados.`,
        },
        {
            index: `3.7`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} poderá fornecer a Parceiros dados estatísticos do Fornecedor para melhorias dos Serviços disponibilizados, segurança e eficiência das atividades, independentemente de consentimento específico. Ademais, dados disponibilizados pelo Usuário para serviços dos Parceiros serão invariavelmente compartilhados para tornar viável a relação do Fornecedor com o Parceiro.`,
        },
    ],
    [
        {
            index: `4.1`,
            title: ``,
            content: `O Usuário acessa sua Conta por meio do login e senha, comprometendo-se a não informar esses dados de acesso a terceiro, responsabilizando-se integralmente pelo uso que deles seja feito.`,
        },
        {
            index: `4.2`,
            title: ``,
            content: `O login e senha para acesso e utilização da Plataforma são personalíssimos e intransferíveis. A ${legalInfos[getPartnerKey()].razaoSocial} não responderá por qualquer uso não autorizado da Plataforma e por quaisquer consequências e/ou desdobramentos daí decorrentes.`,
        },
        {
            index: `4.2.1`,
            title: ``,
            content: `O Fornecedor e o Usuário serão os únicos responsáveis pelas operações efetuadas na Conta, uma vez que o acesso só será possível mediante a utilização de senha pessoal e de seu exclusivo conhecimento.`,
        },
        {
            index: `4.3`,
            title: ``,
            content: `Será integral responsabilidade do Usuário o emprego de senhas facilmente identificáveis como datas comemorativas, sequências numéricas e outras senhas que possam ser descobertas por terceiros.`,
        },
        {
            index: `4.4`,
            title: ``,
            content: `O Usuário compromete-se a notificar a ${legalInfos[getPartnerKey()].razaoSocial}, imediatamente, por meio dos canais de contato mantidos pela ${legalInfos[getPartnerKey()].razaoSocial} na Plataforma, a respeito de qualquer uso não autorizado de sua Conta.`,
        },
        {
            index: `4.5`,
            title: ``,
            content: `O e-mail que o Usuário utiliza para seu cadastro não poderá guardar qualquer semelhança com o nome da ${legalInfos[getPartnerKey()].razaoSocial}.`,
        },
        {
            index: `4.6`,
            title: ``,
            content: `Fornecedor e Usuário deverão manter os aplicativos e meios de acesso à Plataforma atualizados com sua mais recente versão. A ${legalInfos[getPartnerKey()].razaoSocial} sempre informará a disponibilização de novas versões.`,
        },
        {
            index: `4.7`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} não possui responsabilidade ou garante o funcionamento ou compatibilidade da Plataforma com nenhum modelo ou forma de acesso escolhido pelo Usuário, sendo de sua responsabilidade a adequação das formas escolhidas para a regular utilização da Plataforma.`,
        },
    ],
    [
        {
            index: `5.1`,
            title: ``,
            content: `Em nenhuma hipótese será permitida a cessão, a venda, o aluguel ou outra forma de transferência da Conta.`,
        },
        {
            index: `5.1.1`,
            title: ``,
            content: `A conduta referida no item anterior poderá, inclusive, ser eventualmente enquadrada como crime de falsa identidade, punível penalmente nos termos do Código Penal.`,
        },
        {
            index: `5.2`,
            title: ``,
            content: `Não se permitirá, ainda, a criação de novas Contas por pessoas cujos cadastros originais tenham sido cancelados pela ${legalInfos[getPartnerKey()].razaoSocial}.`,
        },
    ],
    [
        {
            index: `6.1`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} envidará todos os esforços razoáveis para manter a plataforma disponível e operacional de forma contínua. No entanto, não garante que a Plataforma estará livre de interrupções, erros ou falhas técnicas.`,
        },
        {
            index: `6.1.1`,
            title: ``,
            content: `Em caso de indisponibilidade total ou parcial da Plataforma, o Fornecedor concorda que a ${legalInfos[getPartnerKey()].razaoSocial} estará isenta por quaisquer perdas, danos ou prejuízos incorridos, incluindo, mas não se limitando, a perda de dados, interrupção dos negócios, lucros cessantes ou qualquer outro dano consequencial.`,
        },
        {
            index: `6.2`,
            title: ``,
            content: `Na hipótese de indisponibilidade total ou parcial da Plataforma, o Fornecedor poderá contatar a ${legalInfos[getPartnerKey()].razaoSocial} em seus canais de atendimento.`,
        },
    ],
    [
        {
            index: `7.1`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} é mera solução de tecnologia viabilizadora das negociações ocorridas com a contratação de Serviços, sem qualquer participação ou relação com estas. Os Serviços ofertados por Parceiro na Plataforma são realizados por este junto ao Fornecedor, de forma independente, inexistindo qualquer participação ou agenciamento pela ${legalInfos[getPartnerKey()].razaoSocial} na realização destes, sem qualquer exigência de carga horária ou de dias trabalhados, inexistindo qualquer sorte de subordinação.`,
        },
        {
            index: `7.2`,
            title: ``,
            content: `Os valores e condições negociais estabelecidos entre Parceiro e Fornecedor serão sempre de total e integral responsabilidade destes, sendo que a ${legalInfos[getPartnerKey()].razaoSocial} não possui quaisquer condições ou parâmetro para precificação destes.`,
        },
        {
            index: `7.3`,
            title: ``,
            content: `Os Parceiros, Fornecedores e Usuários não são colaboradores e nem representantes da ${legalInfos[getPartnerKey()].razaoSocial}, nem de qualquer de suas afiliadas.`,
        },
        {
            index: `7.4`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} não se responsabiliza pela existência, quantidade, qualidade, estado, integridade ou legitimidade do fornecimento de Serviços contratados pelo Fornecedor, assim como pela capacidade para contratar do Fornecedor ou do Parceiro, ou pela veracidade dos dados pessoais por eles fornecidos.`,
        },
        {
            index: `7.5`,
            title: ``,
            content: `A relação de responsabilidade entre Fornecedor e Parceiro pela contratação de Serviços oferecidos por este se dará de forma direta, sem qualquer interferência da ${legalInfos[getPartnerKey()].razaoSocial}. Desse modo, Fornecedor e Parceiro são exclusiva e isoladamente responsáveis por essa relação e por todos os seus desdobramentos, o que inclui eventuais danos, vícios, ou qualquer necessidade de reparação, os quais deverão ser diretamente tratados entre Fornecedor e Parceiro. `,
        },
        {
            index: `7.6`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} não será responsável por ressarcir Fornecedor e seu Usuário por quaisquer gastos com ligações telefônicas, pacotes de dados, SMS, mensagens, e-mails, correspondência ou qualquer outro valor dispendido por estes em razão de contato com a ${legalInfos[getPartnerKey()].razaoSocial}, por qualquer motivo que seja.`,
        },
        {
            index: `7.7`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} não poderá ser responsabilizada pelo efetivo cumprimento das obrigações assumidas pelo Parceiro ou Fornecedor e seus Usuários.`,
        },
        {
            index: `7.8`,
            title: ``,
            content: `O Fornecedor e seus Usuários reconhecem e aceitam que, ao usar a Plataforma, agem por sua conta e risco, reconhecendo a ${legalInfos[getPartnerKey()].razaoSocial} como mero intermediador. Danos ocorridos, ainda que anteriores ou posteriores, direta ou indiretamente, serão assumidos pela parte lesada e pela parte lesadora, sem que qualquer responsabilidade possa ser atribuível à ${legalInfos[getPartnerKey()].razaoSocial}.`,
        },
        {
            index: `7.9`,
            title: ``,
            content: `Caso Fornecedor, Usuário e/ou Parceiro iniciem qualquer tipo de reclamação ou ação legal contra qualquer destes, então todos e cada um dos envolvidos nas reclamações ou ações eximem de toda responsabilidade a ${legalInfos[getPartnerKey()].razaoSocial}, seus diretores, gerentes, empregados, agentes, representantes e procuradores.`,
        },
    ],
    [
        {
            index: `8.1`,
            title: ``,
            content: `A ${legalInfos[getPartnerKey()].razaoSocial} se reserva o direito de excluir unilateralmente e a seu exclusivo critério, cadastros daqueles que pratiquem:`,
        },
        {
            index: `8.1.1`,
            title: ``,
            content: `Ofensa à honra, imagem, reputação e dignidade de terceiros;`,
        },
        {
            index: `8.1.2`,
            title: ``,
            content: `Racismo ou discriminação de qualquer natureza;`,
        },
        {
            index: `8.1.3`,
            title: ``,
            content: `Bullying, stalking ou qualquer outra espécie de constrangimento ilegal ou assédio;`,
        },
        {
            index: `8.1.4`,
            title: ``,
            content: `Manifesta violação a direito autoral ou direito de imagem;`,
        },
        {
            index: `8.1.5`,
            title: ``,
            content: `Utilização de marcas, símbolos, logotipos ou emblemas de terceiros;`,
        },
        {
            index: `8.1.6`,
            title: ``,
            content: `Instigação ou apologia à prática de crimes, como tráfico ou uso de entorpecentes, estupro, homicídio, estelionato, dentre outros;`,
        },
        {
            index: `8.1.7`,
            title: ``,
            content: `Erros ou suspeita de equívocos.`,
        },
        {
            index: `8.2`,
            title: ``,
            content: `Eventuais denúncias poderão gerar, ainda que preventivamente, a suspensão ou o cancelamento da Conta da Fornecedor. `,
        },
        {
            index: `8.3`,
            title: ``,
            content: `Ainda, a exclusão poderá ocorrer caso quaisquer das previsões estabelecidas neste Termo e demais políticas sejam violadas pela Fornecedor ou Usuário.`,
        },
    ],
    [
        {
            index: `9.1`,
            title: ``,
            content: `O uso comercial da expressão “${legalInfos[getPartnerKey()].razaoSocial}” como marca, nome empresarial ou nome de domínio, bem como os logos, marcas, insígnias, conteúdo das telas relativas à Plataforma e o conjunto de programas, bancos de dados, redes e arquivos que permitem que o Fornecedor e seus Usuários acessem e usem suas Contas, são propriedade da ${legalInfos[getPartnerKey()].razaoSocial} e estão protegidos pelas leis e pelos tratados internacionais de direito autoral, de marcas, de patentes, de modelos e de desenhos industriais.`,
        },
        {
            index: `9.2`,
            title: ``,
            content: `O uso indevido e a reprodução total ou parcial dos referidos conteúdos são proibidos, salvo com prévia autorização expressa da ${legalInfos[getPartnerKey()].razaoSocial}.`,
        },
        {
            index: `9.3`,
            title: ``,
            content: `É vedada a utilização de dispositivo, software ou outro recurso que possa interferir nas atividades e nas operações da ${legalInfos[getPartnerKey()].razaoSocial}, bem como nas transações e seus bancos de dados.`,
        },
        {
            index: `9.4`,
            title: ``,
            content: `Qualquer intromissão, tentativa de, ou atividade que viole ou contrarie propriedade intelectual e as proibições estipuladas neste Termo tornará o responsável passível de sofrer os efeitos das ações legais pertinentes, bem como as sanções aqui previstas, sendo ainda responsável por indenizar a ${legalInfos[getPartnerKey()].razaoSocial} ou seus Parceiros, Fornecedores e Usuários por eventuais danos causados.`,
        },
        {
            index: `9.5`,
            title: ``,
            content: `Quaisquer tentativas de violar, manipular ou copiar os códigos-fonte da ${legalInfos[getPartnerKey()].razaoSocial} serão tratadas como crime e punidas na forma da Lei.`,
        },
    ],
    [
        {
            index: `10.1`,
            title: ``,
            content: `A privacidade e a proteção de dados pessoais, bem como o sigilo de informações trocadas a partir da Plataforma são temas regulados na Política de Privacidade, documento diverso e vinculado a esse Termo.`,
        },
    ],
    [
        {
            index: `11.1`,
            title: ``,
            content: `O Fornecedor poderá cancelar sua Conta a qualquer momento, sem qualquer custo ou outra condicionante, desde que não haja qualquer compromisso e/ou agendamento em andamento, firmado por meio da Plataforma.`,
        },
        {
            index: `11.2`,
            title: ``,
            content: `Para cancelar sua Conta, a Fornecedor deverá seguir as instruções disponíveis em sua Conta na Plataforma.`,
        },
    ],
    [
        {
            index: `12.1`,
            title: ``,
            content: `Quando o Fornecedor tiver qualquer dúvida, comentário ou reclamação, sempre poderá entrar em contato com a ${legalInfos[getPartnerKey()].razaoSocial} por meio de qualquer um dos canais de comunicação abaixo, que podem vir a ser atualizados:`,
        },
        {
            index: `12.2`,
            title: ``,
            content: `Telefone: ${legalInfos[getPartnerKey()].telefone}`,
        },
        {
            index: `12.3`,
            title: ``,
            content: `E-mail: ${legalInfos[getPartnerKey()].email}`,
        },
        {
            index: `12.4`,
            title: ``,
            content: `Endereço: ${legalInfos[getPartnerKey()].endereco}`,
        },
        {
            index: `12.5`,
            title: ``,
            content: `Os canais de atendimento da ${legalInfos[getPartnerKey()].razaoSocial} estarão disponíveis de segunda a sexta, entre 09h00 e 18h00, no horário de Brasília. Não haverá atendimento em feriados nacionais, estaduais ou municipais ocorridos na capital do Estado de São Paulo.`,
        },
    ],
    [
        {
            index: `13.1`,
            title: ``,
            content: `Todos os itens destes Termos são regidos pelas leis vigentes na República Federativa do Brasil. `,
        },
        {
            index: `13.2`,
            title: ``,
            content: `Para todos os assuntos referentes à interpretação, ao cumprimento ou a qualquer outro questionamento relacionado a este Termo, as partes concordam em se submeter ao Foro da Comarca de São Paulo.`,
        },
    ],

]

export default termsInfo